import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DeviceCardComponent } from './device-card/device-card.component';
import { DeviceService } from '../../../../services/devices/device.service';
import { AsyncPipe } from '@angular/common';
import { MatList } from '@angular/material/list';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SessionSettingsTestIds } from './session-settings.test-ids';

@Component({
  selector: 'app-session-settings',
  imports: [DeviceCardComponent, AsyncPipe, MatList],
  templateUrl: './session-settings.component.html',
  styleUrl: './session-settings.component.scss'
})
/**
 * Mit dieser Komponente wird das DeviceManagement für einzelne SB-User umgesetzt. Speziell wird hier
 * die Liste der Devices angezeigt.
 * Hierdurch erfüllte AFOs:
 * A_25395-03 - Matrix Module (Device Management)
 */
export class SessionSettingsComponent implements OnInit {
  protected readonly testIds = SessionSettingsTestIds;
  private readonly deviceService: DeviceService = inject(DeviceService);
  devices$ = this.deviceService.getDevices$();
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.devices$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }
}
